export const formatRows = (listaItems) =>
  listaItems.map((item) => ({
    id: item.id || "Id no disponible",
    codigo_subrubro: item.codigo_subrubro || "Código no disponible",
    descripcion_subrubro: item.descripcion_subrubro || "Subrubro no disponible",
    descripcionRamo: item.su_rubro?.su_ramo?.descripcion_ramo || "Ramo no disponible",
    descripcionRubro: item.su_rubro?.descripcion_rubro || "Rubro no disponible",
  }));
